import { Modal as SemanticModal } from 'semantic-ui-react';

export { ModalProps, StrictModalProps } from 'semantic-ui-react';

export const Modal: typeof SemanticModal = SemanticModal;

export default Modal;
